// 稼働表を更新する mutation（一括反映・一括解除・先週/先月コピー）に付与する mutationKey。
// App の MutationCache がこの key を判定して invalidate する（画面 unmount 後の完了でも再取得するため）。
// 実行中かどうかの判定は TruckShiftUpdateProvider（useTruckShiftUpdate().isUpdating）で行う。
// ※ React Query v4 の useIsMutating は別画面から実行中 mutation を検知できないため使わない。
export const TRUCK_SHIFT_UPDATE_MUTATION_KEY = ['truckShiftUpdate'];
